(function ($, waTheme) {

    var ProductsFilter = (function ($) {

        ProductsFilter = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$units = that.$wrapper.find(".s-units-section");
            that.$form = that.$wrapper.find("form");

            // VARS

            // DYNAMIC VARS
            that.is_locked = false;

            // INIT
            that.initClass();
        };

        ProductsFilter.prototype.initClass = function () {
            var that = this;
            //
            // if (!waTheme.is_touch_enabled) {
                that.initRangeSlider();
            // }
            //
            that.bindEvents();

            window.addEventListener('popstate', function (event) {
                location.reload();
            });
        };

        ProductsFilter.prototype.initRangeSlider = function () {
            var that = this,
                $ranges = that.$wrapper.find(".s-range-item");

            var RangeSlider = (function ($) {

                var template =
                    '<div class="s-range-slider">' +
                    '<div class="r-bar-wrapper">' +
                    '<span class="r-bar"></span>' +
                    '<span class="r-point left"></span>' +
                    '<span class="r-point right"></span>' +
                    '</div>' +
                    '</div>';

                RangeSlider = function (options) {
                    var that = this;

                    // DOM
                    that.$wrapper = options["$wrapper"];
                    that.$inputMin = options["$inputMin"];
                    that.$inputMax = options["$inputMax"];

                    // VARS
                    that.min = options["min"];
                    that.max = options["max"];
                    that.left_value = options["left_value"];
                    that.right_value = options["right_value"];
                    that.move_class = "is-move";
                    that.active_class = "is-active";

                    // DYNAMIC DOM
                    that.$rangeWrapper = false;
                    that.$leftPoint = false;
                    that.$rightPoint = false;
                    that.$bar = false;
                    that.$activePoint = false;

                    // DYNAMIC VARS
                    that.left = 0;
                    that.right = 100;
                    that.range_left = false;
                    that.range_width = false;

                    // INIT
                    that.initClass();
                };

                RangeSlider.prototype.initClass = function () {
                    var that = this;

                    that.$rangeWrapper = $(template);
                    that.$leftPoint = that.$rangeWrapper.find(".r-point.left");
                    that.$rightPoint = that.$rangeWrapper.find(".r-point.right");
                    that.$barWrapper = that.$rangeWrapper.find(".r-bar-wrapper");
                    that.$bar = that.$rangeWrapper.find(".r-bar");
                    that.$wrapper.after(that.$rangeWrapper);

                    that.changeRange();

                    that.bindEvents();
                };

                RangeSlider.prototype.bindEvents = function () {
                    var that = this,
                        move_class = that.move_class,
                        $document = $(document),
                        $body = $("body"),
                        no_select = "user-select-none";

                    that.$rangeWrapper.on("mousedown touchstart", ".r-point", function () {
                        that.$activePoint = $(this);
                        that.range_left = that.$barWrapper.offset().left;
                        that.range_width = that.$barWrapper.outerWidth();

                        // No selection then moving
                        $body.addClass(no_select);

                        //
                        // that.is_locked = true;

                        // Add sub events
                        $document.on("mousemove touchmove", onMouseMove);
                        $document.on("mouseup touchend", onMouseUp);
                    });

                    that.$inputMin.on("keyup", function () {
                        var $input = $(this),
                            val = parseInt($input.val());

                        if (!(val >= 0)) {
                            val = 0;
                        }

                        if (val < that.min) {
                            val = that.min;
                        }

                        if (val >= that.max) {
                            val = that.max * .99;
                        }

                        that.left_value = val;
                        that.changeRange();
                    });

                    that.$inputMax.on("keyup", function () {
                        var $input = $(this),
                            val = parseInt($input.val());

                        if (!(val >= 0)) {
                            val = that.max;
                        }

                        if (val > that.max) {
                            val = that.max;
                        }

                        if (val <= that.left_value) {
                            val = that.left_value * 1.01;
                        }

                        that.right_value = val;
                        that.changeRange();
                    });

                    that.$wrapper.closest("form").on("reset", function (event) {
                        that.setRange(0, 100, true);
                    });

                    function onMouseMove(event) {
                        var $point = that.$activePoint;
                        if (that.$activePoint) {
                            // Add move Class
                            var is_move = $point.hasClass(that.move_class);
                            if (!is_move) {
                                $point.addClass(that.move_class);
                            }
                            // Do moving
                            that.prepareSetRange(event, $point);
                        }
                    }

                    function onMouseUp() {
                        $document.off("mousemove touchmove", onMouseMove);
                        $document.off("mouseup touchend", onMouseUp);
                        $body.removeClass(no_select);
                        if (that.$activePoint) {
                            that.$activePoint.removeClass(move_class);
                            that.$activePoint = false;
                        }

                        //
                        that.is_locked = false;

                        //
                        that.$wrapper.closest("form").trigger("change");
                    }
                };

                RangeSlider.prototype.prepareSetRange = function (event, $point) {
                    var that = this,
                        is_left = ($point[0] == that.$leftPoint[0]),
                        delta, percent, min, max;

                    if (event.type == "touchmove") {
                        event.pageX = event.originalEvent.changedTouches[0].pageX;
                        event.clientX = event.originalEvent.changedTouches[0].clientX;
                    }

                    //
                    delta = (event.pageX || event.clientX) - that.range_left;
                    if (delta < 0) {
                        delta = 0;
                    } else if (delta > that.range_width) {
                        delta = that.range_width;
                    }
                    //
                    percent = (delta / that.range_width) * 100;

                    // Min Max
                    var min_points_place = 7; // 7%
                    if (is_left) {
                        min = 0;
                        max = that.right - min_points_place;
                    } else {
                        min = that.left + min_points_place;
                        max = 100;
                    }
                    if (percent < min) {
                        percent = min;
                    } else if (percent > max) {
                        percent = max;
                    }

                    // Set Range
                    if (is_left) {
                        that.setRange(percent, that.right);
                    } else {
                        that.setRange(that.left, percent);
                    }
                };

                RangeSlider.prototype.setRange = function (left, right, not_change_input) {
                    var that = this,
                        result_left = 0,
                        result_right = 100;

                    if (left && left >= 0 && left < result_right) {
                        result_left = left;
                    }

                    if (right && right > 0 && right <= result_right && right > result_left) {
                        result_right = right;
                    }

                    // Set data
                    that.left = result_left;
                    that.right = result_right;

                    // Render
                    that.$leftPoint.css("left", result_left + "%");
                    that.$rightPoint.css("left", result_right + "%");

                    if (!not_change_input) {
                        var delta_value = that.max - that.min,
                            min_val = that.min + that.left * delta_value / 100,
                            max_val = that.min + that.right * delta_value / 100;

                        var min = that.min === parseInt(min_val * 10) / 10 ? null : parseInt(min_val * 10) / 10;
                        var max = that.max === parseInt(max_val * 10) / 10 ? null : parseInt(max_val * 10) / 10;

                        that.$inputMin.val(min);
                        that.$inputMax.val(max);
                    }

                    // Bar
                    that.setBar();

                };

                RangeSlider.prototype.setBar = function () {
                    var that = this;
                    that.$bar.css({
                        width: Math.floor(that.right - that.left) + "%",
                        left: that.left + "%"
                    });
                };

                RangeSlider.prototype.changeRange = function () {
                    var that = this;

                    // Set Range at Start
                    var left_value = that.left,
                        right_value = that.right,
                        delta_value = that.max - that.min;

                    if (that.left_value && that.left_value >= that.min && that.left_value < that.max) {
                        left_value = ((that.left_value - that.min) / delta_value) * 100;
                    }

                    if (that.right_value && that.right_value > left_value && that.right_value <= that.max) {
                        right_value = ((that.right_value - that.min) / delta_value) * 100;
                    }

                    that.setRange(left_value, right_value, true);
                };

                return RangeSlider;

            })(jQuery);

            $ranges.each(function () {
                var $range = $(this),
                    $inputMin = $range.find(".min"),
                    $inputMax = $range.find(".max"),
                    min = +$range.data("min"),
                    max = +$range.data("max"),
                    left = +$inputMin.val(),
                    right = +$inputMax.val();

                if ($inputMin.length && $inputMax.length && min >= 0 && max > 0) {
                    var range_slider = new RangeSlider({
                        min: min,
                        max: max,
                        left_value: left,
                        right_value: right,
                        $wrapper: $range,
                        $inputMin: $inputMin,
                        $inputMax: $inputMax
                    });

                    $range.data("range_slider", range_slider);
                }
            });
        };

        ProductsFilter.prototype.bindEvents = function () {
            var that = this;

            that.$units.on("click", ".s-units-section__btn", function () {
                var $field = that.$units.find("[name=\"unit\"]"),
                    unit_id = $(this).data("id");

                unit_id = (typeof unit_id !== "undefined" ? "" + unit_id : "");
                $field.val(unit_id);

                that.$units.find("button.btn").removeClass("active");
                $(this).addClass("active");

                resetSlider($(this), this);

                that.onSubmit(that.$form);
            });

            that.$units.on("click", ".dropdown-item", function (event) {
                var $field = $(this).closest(".s-units-section").find("[name=\"unit\"]");
                var unit_id = $(this).data("id");
                var unit_text = $(this).text();

                that.$form.find("#js-filter-units-dropdown .dropdown-item").removeClass("text-theme");
                $(this).addClass("text-theme");
                $(this).parent().prev().text(unit_text);

                unit_id = (typeof unit_id !== "undefined" ? "" + unit_id : "");
                $field.val(unit_id);

                resetSlider($(this), this);

                that.onSubmit(that.$form);
            });

            function resetSlider($unit, that) {
                var min = Math.floor($unit.data("min")),
                    max = Math.ceil($unit.data("max")),
                    $range = $(that).parents(".s-filter-group").find(".s-range-item"),
                    $inputMin = $range.find(".min"),
                    $inputMax = $range.find(".max"),
                    slider = $range.data("range_slider");

                if ($inputMin.length && $inputMax.length && min >= 0 && max > 0) {
                    $range.attr({"data-min": min, "data-max": max});
                    $inputMin.val("").attr("placeholder", min);
                    $inputMax.val("").attr("placeholder", max);

                    if (slider) {
                        slider.min = min;
                        slider.max = max;
                        slider.setRange(0, 100, true);
                    }
                }
            }

            // On submit form
            that.$form.on("submit change", function (event) {
                event.preventDefault();
                if (!that.is_locked) {
                    that.onSubmit($(this));
                }
                return false;
            });

            that.$form.on("reset", function (event) {
                setTimeout(function () {
                    // Очищаем поля
                    var $inputs = that.$form.find("input[type=text]");
                    if ($inputs.length) {
                        $inputs.val("");
                    }

                    // Очищаем юниты
                    var $units = $("#js-filter-units-dropdown").find("[data-id='']");
                    if ($units.length) {
                        $units.trigger("click");
                    }

                    if (!that.is_locked) {
                        that.onSubmit(that.$form, true);
                    }
                }, 0);
            });

            // Reset Filter Group
            that.$form.find(".js-filter-clear").on("click", function () {
                event.preventDefault();
                if (!that.is_locked) {
                    // Если только одна характеристика выбрана - ресетим форму
                    let reset = that.$form.find(".s-filter-group.active").length === 1;

                    that.clearGroup(that.$form, $(this).parents(".s-filter-group"), reset);
                }
                return false;
            });

            // Reset by Button
            $(document).on("click", ".js-filter-reset", function () {
                that.$form.trigger("reset");
            });

            that.is_locked = false;
        };

        ProductsFilter.prototype.onSubmit = function ($form, reset = false) {
            var that = this,
                href = $form.attr("action"),
                data = reset === false ? $form.serializeArray() : [],
                $category = $("#s-category-wrapper");

            data = performData(data);

            // Lock
            // that.is_locked = true;

            // Animation
            let loader = `<div class="b-products-spinner position-absolute start-50 translate-middle">
                            <div class="spinner-border text-gray-500" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </div>`;
            $category.find(".s-products-list").addClass("is-loading user-select-none pe-none");
            $category.find(".s-products-list").append(loader);

            $.get(href, data)
                .always(function () {
                    that.is_locked = false;
                })
                .done(function (html) {

                    // Insert new html
                    if ($category.length) {
                        let $html = $("<div></div>").html(html);
                        let $empty = $html.find(".s-category-empty");

                        if ($empty.length) {
                            if ($category.find(".s-category-empty").length === 0) $empty.appendTo($category);
                            $category.find(".s-products-list").addClass("d-none");
                            $category.find(".s-paging-wrapper").addClass("d-none");
                        } else {
                            $category.replaceWith(html);

                            // Для фильтрации над товарами
                            if (that.$wrapper.hasClass("b-category-filters") !== false) {
                                // Инициализируем заново фильтрацию
                                new window.waTheme.init.shop.ProductsFilter({
                                    $wrapper: $(".s-category-filters"),
                                });
                            }

                            // Инициализируем заново сортировку
                            new window.waTheme.init.shop.ProductsActions({
                                $wrapper: $(".s-sorting-wrapper"),
                            });

                            // Инициализируем заново товары
                            new window.waTheme.init.shop.ProductsInit();

                            // Обновляем инстанс ленивой загрузки картинок
                            waTheme.init.site.ImageLazyLoad.update();
                        }
                    }

                    // history change
                    if ("pushState" in window.history) {
                        history.pushState({
                            reload: true
                        }, "", location.origin + location.pathname + "?" + data);
                    }
                });

            if (data === "" || data === "?" || data === "unit=0") {
                reset = true;
            }

            that.checkFilterGroup($form, $form.serializeArray(), reset);

            function performData(data) {
                var result = [];

                data = formatData(data);

                $.each(data, function (index, item) {
                    if (item.value) {
                        result.push(item.name + "=" + item.value);
                    }
                });

                return result.join("&");

                function formatData(form_array) {
                    var result = [];

                    let searchParams = new URLSearchParams(window.location.search),
                        sort_params = ["order", "sort", "sort_unit"];

                    $.each(sort_params, function (i, sort_param) {
                        if (searchParams.has(sort_param)) {
                            result.push({
                                name: sort_param,
                                value: searchParams.get(sort_param)
                            });
                        }
                    });

                    $.each(form_array, function (i, field) {
                        var full_name = field.name,
                            search_string = "[unit]";

                        var is_unit = (full_name.substr(-(search_string.length)) === search_string);
                        if (is_unit) {
                            var param_name = full_name.substr(0, full_name.length - search_string.length);
                            var is_param_set = checkParam(param_name);
                            if (is_param_set) {
                                result.push(field);
                            }

                        } else {
                            result.push(field);
                        }
                    });

                    return result;

                    function checkParam(param_name) {
                        var result = false;

                        $.each(form_array, function (i, field) {
                            if (field.name === param_name + "[min]" || field.name === param_name + "[max]") {
                                if (field.value.length) {
                                    result = true;
                                    return true;
                                }
                            }
                        });

                        return result;
                    }
                }
            }
        };

        ProductsFilter.prototype.checkFilterGroup = function ($form, data, reset) {
            var that = this,
                empty_price = true,
                active_class = "active";
                // range_array = ["price_min", "price_max"];

            $form.find(".s-filter-group").removeClass(active_class);

            // Возвращаем при сбросе фильтра
            if (reset) {
                $form.find("button:reset").addClass("d-none");
                // Для мобильной фильтрации
                that.$wrapper.parents(".offcanvas").find(".js-filter-reset").addClass("d-none");
                return;
            }

            // Чекаем выбранные характеристики в фильтре
            data.forEach(function (item) {
                if (item["value"] === "") {
                    if ((item["name"] === "price_min" || item["name"] === "price_max") && empty_price === true) {
                        $form.find(".s-filter-group.price").removeClass(active_class);
                    } else {
                        $form.find(`.s-filter-group.${item["name"].replace('[]', '')}`).removeClass(active_class);
                    }
                } else {
                    if (item["name"] === "price_min" || item["name"] === "price_max") {
                        empty_price = false;
                        $form.find(".s-filter-group.price").addClass(active_class);
                    } else {
                        $form.find(`.s-filter-group.${item["name"].replace('[]', '')}`).addClass(active_class);
                    }
                }
            });

            $form.find("button:reset").removeClass("d-none");
            // Для мобильной фильтрации
            that.$wrapper.parents(".offcanvas").find(".js-filter-reset").removeClass("d-none");
        };

        ProductsFilter.prototype.clearGroup = function ($form, $group, reset = false) {
            var that = this;

            $group.removeClass("active");

            $group.find(".s-range-item").each(function () {
                $(this).find("input[name=\"price_min\"]").val("").trigger("keyup");
                $(this).find("input[name=\"price_max\"]").val("").trigger("keyup");
            });

            $group.find("input[type=\"checkbox\"]").each(function () {
                $(this).prop('checked', false);
            });

            $group.find("input[type=\"radio\"]").each(function () {
                var id = $(this).attr("id"),
                    is_any = (id.substr(id.length - 3) === "Any");
                if (is_any) {
                    $(this).prop("checked", true);
                }
            });

            that.onSubmit($form, reset);
        }

        return ProductsFilter;

    })($);

    var ProductsActions = ( function($) {

        ProductsActions = function(options = {}) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];

            // DYNAMIC VARS
            that.loader = `<div class="b-products-spinner position-absolute start-50 translate-middle">
                                <div class="spinner-border text-gray-500" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                           </div>`;

            // INIT
            that.init();
        };

        ProductsActions.prototype.init = function() {
            var that = this;

            that.bindEvents();

        };

        ProductsActions.prototype.bindEvents = function() {
            var that = this;

            // Sorting
            that.$wrapper.on("click", ".js-products-set-sort", function(event) {
                event.preventDefault();
                // that.onChangeSort($(this));
                that.onChangeSorting($(this), true);
            });

            // View
            that.$wrapper.on("click", ".js-products-set-view", function(event) {
                event.preventDefault();
                // that.onChangeView($(this));
                that.onChangeSorting($(this), false);
            });
        };

        ProductsActions.prototype.onChangeSorting = function ($button, sorting) {
            var that = this,
                $category = $("#s-category-wrapper"),
                href = sorting ? $button.attr("href") : new URL(window.location.href),
                view_type = sorting ? false : $button.data("view");

            console.log(view_type);

            $category.find(".s-products-list").addClass("is-loading");
            $category.find(".s-products-list").addClass("is-loading user-select-none pe-none");
            $category.find(".s-products-list").append(that.loader);

            if (sorting === false) {
                $.cookie("products-view", view_type, {expires: 365, path: '/'});
            }

            $.get(href)
                .done(function (html) {

                    if ($category.length) {
                        let $html = $("<div></div>").html(html);
                        let $empty = $html.find(".s-category-empty");

                        if ($empty.length) {
                            if ($category.find(".s-category-empty").length === 0) $empty.appendTo($category);
                            $category.find(".s-products-list").addClass("d-none");
                        } else {
                            $category.replaceWith(html);

                            // Для фильтрации над товарами
                            if ($(".s-category-filters").hasClass("b-category-filters") !== false) {
                                // Инициализируем заново фильтрацию
                                new window.waTheme.init.shop.ProductsFilter({
                                    $wrapper: $(".s-category-filters"),
                                });
                            }

                            // Инициализируем заново сортировку
                            new window.waTheme.init.shop.ProductsActions({
                                $wrapper: $(".s-sorting-wrapper"),
                            });

                            // Инициализируем заново товары
                            new window.waTheme.init.shop.ProductsInit();

                            // Обновляем инстанс ленивой загрузки картинок
                            waTheme.init.site.ImageLazyLoad.update();
                        }
                    }

                    if (sorting) {
                        if ("pushState" in window.history) {
                            history.pushState({
                                reload: true
                            }, "", location.origin + location.pathname + href);
                        }
                    }
                });
        };

        return ProductsActions;

    })($);

    var ComparePage = (function ($) {

        ComparePage = function (options) {
            var that = this;

            // DOM
            that.$wrapper = options["$wrapper"];
            that.$type_toggle = that.$wrapper.find("button.dropdown-toggle");
            that.$products = $(".s-compare-products .s-product-wrapper");

            //
            that.type = "all_types";
            that.diff = undefined;
            that.loader = `<div class="b-products-spinner position-absolute start-50 translate-middle">
                                <div class="spinner-border text-gray-500" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                           </div>`;

            // INIT
            that.init();
        };


        ComparePage.prototype.init = function() {
            var that = this;

            that.productsEqualHeight();

            that.$wrapper.on("click", ".js-compare-type-filter", function() {
                that.updateToggle($(this));
                that.updateProducts($(this));
            });

            that.$wrapper.on("change", ".js-compare-diff-filter", function() {
                that.diff = $(this).attr("checked");
                that.sameToggle();
            });

            that.$wrapper.on("click", ".js-reset-compare", function (event) {
                event.preventDefault();
                $.cookie('shop_compare', null, {path: '/'});
                location.href = location.href.replace(/compare\/.*/, 'compare/');
            });

            that.$wrapper.on("click", ".js-remove-button", function (event) {
                event.preventDefault();
                var $product = $(this).closest(".s-product-wrapper"),
                    type = $product.data("product-type"),
                    id = $product.data("product-id");

                if (id) {
                    that.removeProduct(id, type);
                    that.updateProducts($(this));
                }
            });
        };

        ComparePage.prototype.productsEqualHeight = function() {
            var that = this,
                $products = $(".s-compare-products"),
                $features = $products.find(".swiper-wrapper > .swiper-slide:first-child .b-products-grid-compare-features__feature");

            $features.each(function () {
                var index = $(this).data("index"),
                    height = $(this).outerHeight(),
                    $elements = $products.find(`.b-products-grid-compare-features__feature[data-index="${index}"]`);

                $elements.each(function () {
                    if ($(this).outerHeight() > height) {
                        height = $(this).outerHeight();
                    }
                });

                $(this).css('height', height);
                $elements.css('height', height);
            });
        }

        ComparePage.prototype.updateToggle = function($button) {
            var that = this,
                html = $button.html(),
                active_class = "active";

            that.$wrapper.find(".js-compare-type-filter").removeClass(active_class);
            $button.addClass(active_class);

            that.$type_toggle.html(html);
        }

        ComparePage.prototype.sameToggle = function () {
            var that = this,
                $sameFields = that.$wrapper.find(".b-products-grid-compare-features__feature.same"),
                show_diff = that.diff === "checked";

            if (show_diff) {
                $sameFields.hide();
            } else {
                $sameFields.show();
            }
        };

        ComparePage.prototype.updateProducts = function ($button) {
            var that = this,
                $products = $(".s-compare-products"),
                href = $button.data("href");

            $products.find(".s-products-list").addClass("is-loading");
            $products.find(".s-products-list").addClass("is-loading user-select-none pe-none");
            $products.find(".s-products-list").append(that.loader);

            $.get(href)
                .done(function (html) {

                    if ($products.length) {
                        let $html = $("<div></div>").html(html);
                        let $empty = $html.find(".s-compare-empty");

                        if ($empty.length) {
                            that.$wrapper.replaceWith($empty);
                        } else {

                            $products.replaceWith($html.find(".s-compare-products"));

                            // Инициализируем заново товары
                            new window.waTheme.init.shop.ProductsInit();

                            // Инициализируем swiper
                            new window.waTheme.init.site.Swiper();

                            // Обновляем инстанс ленивой загрузки картинок
                            waTheme.init.site.ImageLazyLoad.update();

                            //
                            that.productsEqualHeight();

                            //
                            that.sameToggle();
                        }
                    }
                });
        };

        ComparePage.prototype.removeProduct = function (id,type) {
            var that = this;

            var compare = $.cookie('shop_compare');
            compare = (compare) ? compare.split(',') : [];

            var index = $.inArray(id + '', compare);
            if (index !== -1) {
                compare.splice(index, 1)
            }
            if (compare.length > 0) {
                $.cookie('shop_compare', compare.join(','), { expires: 30, path: '/'});
            } else {
                $.cookie('shop_compare', null, {path: '/'});
            }

            waTheme.apps["shop"].compare.update();

            var count_all = (parseInt(that.$wrapper.find(`.js-compare-type-filter[data-type="all_types"] .b-compare-filter__count`).text()) - 1);
            var count = (parseInt(that.$wrapper.find(`.js-compare-type-filter[data-type="${type}"] .b-compare-filter__count`).text()) - 1);
            if (count > 0) {
                that.$type_toggle.find(".b-compare-filter__count").text(count);
                that.$wrapper.find(`.js-compare-type-filter[data-type="all_types"] .b-compare-filter__count`).text(count_all);
                that.$wrapper.find(`.js-compare-type-filter[data-type="${type}"] .b-compare-filter__count`).text(count);
            } else {
                that.$wrapper.find(`.js-compare-type-filter[data-type="all_types"]`).addClass("active");
                that.$wrapper.find(`.js-compare-type-filter[data-type="all_types"] .b-compare-filter__count`).text(count_all);
                that.$wrapper.find(`.js-compare-type-filter[data-type="${type}"]`).addClass("is-hidden");

                var html = that.$wrapper.find(`.js-compare-type-filter[data-type="all_types"]`).html();
                that.$type_toggle.html(html);
            }


        };

        return ComparePage;

    })(jQuery);

    waTheme.init.shop.ProductsFilter = ProductsFilter;
    waTheme.init.shop.ProductsActions = ProductsActions;
    waTheme.init.shop.ComparePage = ComparePage;

    // Filters
    let $filters = $(".s-category-filters");
    if ($filters.length) {
        new window.waTheme.init.shop.ProductsFilter({
            $wrapper: $filters
        });
    }

    // Sorting && Views
    let $sorting = $(".s-sorting-wrapper");
    if ($sorting.length) {
        new window.waTheme.init.shop.ProductsActions({
            $wrapper: $sorting
        });
    }

    // Compare page
    let $compare_page = $("#js-compare-page");
    if ($compare_page.length) {
        new waTheme.init.shop.ComparePage({
            $wrapper: $compare_page,
        });
    }

})(jQuery, window.waTheme);